/* eslint-disable camelcase */

import { defaultTo, get } from 'lodash-es';

import page from '@/mixins/page';
import pagination from '@/mixins/pagination';

/**
 * @module pages/invest/invest020
 * @desc 재무정보 > 공시정보
 * @vue-data {Object} dis=null - 리스트 페이지 통신 결과값 저장
 * @vue-data {Number} year=Number - 현재 년도
 * @vue-data {Array} options=[]] - 셀렉트 박스 년도 목록
 * @vue-data {Boolean} moreBtn=true - 더보기 버튼의 유무
 * @vue-data {Number} yearTo=null - 리스트의 표시할 년도
 */
export default {
  mixins: [page, pagination],
  data() {
    return {
      dis    : null,
      year   : new Date().getFullYear() + '년',
      options: [],
      moreBtn: true,
      yearTo : null,
      start  : null,
      end    : null
    };
  },
  mounted() {
    this.start = new Date().getFullYear() + '0101';
    this.end = new Date().getFullYear() + '1231';

    this.options = Array.from({ length: 5 })
      .fill(new Date().getFullYear())
      .map((item, idx) => item - idx + '년');
    this.$nextTick(() => {
      this.loadDisInfo();
    });
  },
  watch: {
    year(thisY) {
      this.yearTo = this.getNum(thisY);
      this.listItems = null;
      this.start = this.yearTo + '0101';
      this.end = this.yearTo + '1231';
      if (this.curPageIdx === 0) {
        this.loadDisInfo();
      } else {
        this.params.year = this.yearTo;
        this.curPageIdx = 0;
        this.loadDisInfo();
      }
    }
  },
  methods: {
    /**
     * 공시정보 번호 폼에 맞춰 replace
     * @param {String} value 변환 할 문자열
     * @returns 폼에 맞게 html 변환 후 반환
     */
    getNo(value) {
      return value.replaceAll(/^(\d{8})(\d+)$/g, '$1<br />$2');
    },
    /**
     * 날짜 replace
     * @param {String} value 변환 할 문자열
     * @returns 입력값 yyyy-mm-dd 으로 변환 후 반환
     */
    getDate(value) {
      return value.replaceAll(/^(\d{4})(\d{2})(\d{2})$/g, '$1-$2-$3');
    },
    /**
     * 문자열에서 숫자 추출
     * @param {String} value 변환 할 문자열
     * @returns 문자열에서 숫자만 반환
     */
    getNum(value) {
      return value.replace(/[^0-9]/g, '');
    },
    /**
     * 리스트 페이지 통신
     */
    loadDisInfo() {
      if (this.device === 'mo') {
        this.loadPageData({
          uri   : '/api/investList.do',
          params: {
            corp_code : '00770455',
            crtfc_key : 'f7daaf3990a49a24f8c3bffdd214bb9364d6220f',
            year      : this.yearTo,
            page_count: 10,
            start     : this.start,
            end       : this.end,
            page_no   : this.curPageIdx + 1
          },
          callback: (res) => {
            console.log('!!!!! dis info :', res);

            // 더보기 버튼
            if (this.listItems !== null) {
              this.listItems = this.listItems.concat(get(res.data, 'list', []));
            } else {
              // 초기화
              this.listItems = get(res.data, 'list');
            }
            this.totalPageN = defaultTo(
              parseInt(get(res.data, 'total_page')),
              1
            );
          }
        });
      } else {
        this.loadPageData({
          uri   : '/api/investList.do',
          params: {
            corp_code : '00770455',
            crtfc_key : 'f7daaf3990a49a24f8c3bffdd214bb9364d6220f',
            year      : this.yearTo,
            page_count: 10,
            start     : this.start,
            end       : this.end,
            page_no   : this.curPageIdx + 1
          },
          callback: (res) => {
            this.dis = get(res.data, 'list');

            console.log('!!!!! dis info :', res);

            // this.listItems = this.dis.slice(
            //   this.curPageIdx * this.maxPageCount,
            //   this.curPageIdx * this.maxPageCount + this.maxPageCount
            // );

            this.listItems = get(res.data, 'list', []);

            this.totalPageN = defaultTo(
              parseInt(get(res.data, 'total_page')),
              1
            );
          }
        });
      }
    },
    /**
     * 공시정보 오픈
     * @param {String} num 문서 번호
     */
    clickBbs(num) {
      window.open(
        'http://dart.fss.or.kr/dsaf001/main.do?rcpNo=' + num,
        null,
        'width=1024,height=768'
      );
    }
  }
};
